import ApplicationController from './application_controller';

// Per-goal "Hide graph" toggle on the Goal progress panel. Hidden, the chart
// and its legend give way to a one-line note and the data points below stay;
// shown again, the chart comes back (it renders lazily on first visibility,
// so a graph hidden before it was ever scrolled into view builds on reveal).
// State lives on this element only: per goal, per page load, never persisted.
//
// Every toggle announces itself as `goal-graph-toggle:toggled` so the
// data-point disclosure inside the panel can unfold: with the chart gone the
// rows are the only thing left telling the story. The event fires on the
// click, never on connect, so a list the server opened deliberately (a panel
// with no chart to draw) is never closed behind the reader's back.
//
// Targets:
//   graph   the chart canvas wrapper plus its legend row (hidden together)
//   note    the "Graph hidden" line shown in their place
//   button  the toggle (aria-pressed mirrors the hidden state)
//   icon    the eye / eye-slash icon inside the button
//   label   the "Hide graph" / "Show graph" text inside the button
export default class extends ApplicationController {
  static targets = ['graph', 'note', 'button', 'icon', 'label'];
  static values = { hidden: { type: Boolean, default: false } };

  toggle() {
    this.hiddenValue = !this.hiddenValue;
    this.dispatch('toggled', { detail: { hidden: this.hiddenValue } });
  }

  hiddenValueChanged() {
    const hidden = this.hiddenValue;
    this.graphTargets.forEach((element) => {
      element.hidden = hidden;
    });
    this.noteTargets.forEach((element) => {
      element.hidden = !hidden;
    });
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute('aria-pressed', String(hidden));
      this.buttonTarget.title = hidden ? 'Show the graph' : 'Hide the graph';
    }
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle('bi-eye', hidden);
      this.iconTarget.classList.toggle('bi-eye-slash', !hidden);
    }
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = hidden ? 'Show graph' : 'Hide graph';
    }
  }
}
